import { useSet } from '@capturi/react-utils'
import { Button, Spinner } from '@capturi/ui-components'
import { Box, Flex, Grid, Text } from '@chakra-ui/react'
import React, { useMemo } from 'react'
import { type Integration, useIntegrationTypes } from '../useIntegrationTypes'
import { CurrentlyRunningColumn } from './Column'

const STORAGE_KEY = 'superpowers-currently-running'

const getValues = () => {
  const items = localStorage.getItem(STORAGE_KEY) || ''
  return items.split(',').filter(Boolean)
}

export const CurrentlyRunning: React.FC = () => {
  const { data = [], isLoading, error } = useIntegrationTypes()

  const s = useSet<string>(getValues())

  const sorted = useMemo(
    () => data.toSorted((a, b) => a.name.localeCompare(b.name)),
    [data],
  )
  const integrationsMap = useMemo(
    () => new Map(data.map((i) => [i.type, i])),
    [data],
  )

  const handleSelect = (type: string) => {
    s.has(type) ? s.delete(type) : s.add(type)

    // 🤮
    setTimeout(
      () => localStorage.setItem(STORAGE_KEY, s.toArray().join(',')),
      0,
    )
  }
  const handleReset = () => {
    s.clear()

    localStorage.removeItem(STORAGE_KEY)
  }

  const toShow = useMemo(() => {
    //To add the new selected to the start of the "list"
    //We do some funky stuff
    const result: Integration[] = []
    s.forEach((i) => {
      const r = integrationsMap.get(i)
      if (r) result.push(r)
    })
    const r = result.reverse()

    return r
  }, [s, integrationsMap])

  return (
    <Box>
      <Flex flexWrap="wrap">
        {error && (
          <Text color="danger">
            {error.error} {error.message}
          </Text>
        )}
        {isLoading && <Spinner />}
        {sorted.map((i) => (
          <Tag
            {...i}
            key={i.type}
            isSelected={s.has(i.type)}
            onClick={() => handleSelect(i.type)}
          />
        ))}
      </Flex>
      <Button onClick={handleReset} ml="2" variant="link">
        Clear
      </Button>
      <Box overflowX={'scroll'}>
        <Grid
          templateColumns={{ sm: '1fr', lg: 'repeat(auto-fill, 300px)' }}
          overflowX={'scroll'}
          width={{ sm: '100%', lg: toShow.length * 330 - 30 }}
          gap="30px"
          mt="8"
        >
          {toShow.map((i) => (
            <CurrentlyRunningColumn key={i.type} {...i} />
          ))}
        </Grid>
      </Box>
    </Box>
  )
}

const Tag: React.FC<{
  color: string
  type: string
  name: string
  isSelected: boolean
  onClick: (type: string) => void
}> = ({ color, name, type, isSelected, onClick }) => {
  return (
    <Box
      onClick={() => onClick(type)}
      cursor="pointer"
      py="1"
      px="2"
      m="2"
      as="span"
      color={isSelected ? 'white' : color}
      bg={!isSelected ? 'white' : color}
      border={`${color} solid 1px;`}
      borderRadius={'10px'}
    >
      {name}
    </Box>
  )
}
